const config = {
  accepts:
    "image/jpg,image/jpeg,image/png,image/bmp,image/tif,image/tiff,application/dicom",
  apiName: "api8a82ed48",
  apiUrl: "https://api.epona-intellect-engine.com",
  apiUrl2: "http://localhost:8040",
};
export default config;
